const inspectionHistories = [
    {
        "appNo":"A18082101",
        "type":"initial",
        "inspectors":["王大同(主稽)","陳小明(稽核員)"],
        "inspectionItems":"果汁線 : Natural Benefits 純在葡萄柚蘋果綠茶\n運動飲料線 : 舒跑",
        "inspectionDate":["2018-09-12T08:20:10.000Z","2018-09-13T08:20:10.000Z"],
        "inspectionManDay":2,
        "assessmentDecision": "approve",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "finishedGoodTestName":"杏仁玄米餅",
                "testName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"intertek",
                "paymentUnit":"tseyue",
                "testResult":"qualified"
            },
            {
                "product":"02",
                "testType":"rawMaterial",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301"]}],
                "testCompany":"intertek",
                "paymentUnit":"leezen",
                "testResult":"qualified"
            }
        ]
    },
    {
        "appNo":"A19081102",
        "type":"expandingLine",
        "inspectors":["王大同(主稽)","陳小明(稽核員)","王小玉(實習)"],
        "inspectionItems":"果汁線 : Natural Benefits 純在葡萄柚蘋果綠茶\n運動飲料線 : 舒跑、黑麥汁",
        "inspectionDate":["2019-09-12T08:20:10.000Z"],
        "inspectionManDay":1,
        "assessmentDecision": "reject",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "finishedGoodTestName":"杏仁玄米餅",
                "testName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"intertek",
                "paymentUnit":"tseyue",
                "testResult":"qualified"
            },
            {
                "product":"02",
                "testType":"rawMaterial",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301"]}],
                "testCompany":"intertek",
                "paymentUnit":"leezen",
                "testResult":"qualified"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301"]}],
                "testCompany":"intertek",
                "paymentUnit":"leezen",
                "testResult":"qualified"
            }
        ]
    },
    {
        "appNo":"A20090102",
        "type":"followUp",
        "inspectors":["王大同(主稽)","陳小明(稽核員)","陳曉東(觀察員)"],
        // "inspectionItems":["果汁線/Natural Benefits 純在葡萄柚蘋果綠茶","運動飲料線/舒跑、黑麥汁"],
        "inspectionItems":"果汁線 : Natural Benefits 純在葡萄柚蘋果綠茶、Natural Benefits 食安生技-椰子汁\n運動飲料線 : 舒跑、黑麥汁",
        "inspectionDate":["2020-09-12T08:20:10.000Z"],
        "inspectionManDay":1,
        "assessmentDecision": "suspend",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "finishedGoodTestName":"杏仁玄米餅",
                "testName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"intertek",
                "paymentUnit":"tseyue",
                "testResult":"qualified"
            },
            {
                "product":"02",
                "testType":"rawMaterial",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301"]}],
                "testCompany":"intertek",
                "paymentUnit":"leezen",
                "testResult":"qualified"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301"]}],
                "testCompany":"intertek",
                "paymentUnit":"leezen",
                "testResult":"qualified"
            }
        ]
    }
]

export default inspectionHistories;